import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import * as landlordPayments from 'actions/landlordPaymentsActions';
import { getCotenantPayments } from 'actions/landlordTenantsActions';
import PaymentInfoDialog from 'components/landlord_app/payments/components/PaymentInfoDialog';

import { toFriendlyDateString, formatMoney } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

import MediaQuery from 'react-responsive';
import camelCase from 'lodash/camelCase';

let PaymentsLedger = connect(
  (store) => {
    return {
      tenantDetails: store.landlordTenants.tenantDetails,
      unitPayments: store.landlordTenants.unitPayments,
      currentLanguage: store.locale.currentLanguage,
    };
  },
  { ...landlordPayments, getCotenantPayments }
)(
  class PaymentsLedger extends Component {
    constructor(props) {
      super(props);
      this.state = { isOpen: false };
    }

    wavePayment = (paymentId) => {
      this.props.wavePayment(paymentId).then(() => {
        this.toggleDialog();
        this.props.getCotenantPayments(this.props.tenantDetails.id, true);
      });
    };

    unwavePayment = (paymentId) => {
      this.props.unwavePayment(paymentId).then(() => {
        this.toggleDialog();
        this.props.getCotenantPayments(this.props.tenantDetails.id, true);
      });
    };

    reportPayment = (formData) => {
      this.props.reportPayment(formData).then(() => {
        this.toggleDialog();
        this.props.getCotenantPayments(this.props.tenantDetails.id, true);
      });
    };

    toggleDialog = (paymentId) => {
      if (paymentId) {
        this.props.openPaymentDialog(paymentId).then(() => {
          this.props.getTenantList(paymentId);
          this.setState({ isOpen: true });
        });
        return;
      }
      this.setState({ isOpen: false });
    };

    render() {
      const style = {
        receipt_header: {
          margin: '10px -20px 10px -20px',
          backgroundColor: '#f1f1f1',
          padding: '5px 10px',
          fontSize: '14px',
          fontWeight: '800',
        },
        payment_details: {
          fontSize: '12px',
          marginBottom: '0px',
          textAlign: 'left',
          lineHeight: 1,
        },
        payment_balance_details: {
          fontSize: '12px',
          marginBottom: '0px',
          fontWeight: '800',
        },
        ledgerItem: {
          padding: '10px 0px',
          borderBottom: '1px dashed #eaeaea',
        },
        ledgerItemRow: {
          display: 'flex',
          alignItems: 'center',
        },
        ledgerItemDescription: {
          fontSize: '12px',
          padding: '0px 15px',
        },
      };

      return (
        <div id="payment-ledger-payment-log">
          <PaymentInfoDialog isOpen={this.state.isOpen} toggleDialog={this.toggleDialog} />
          <div className="row" style={{ marginTop: '-10px', paddingBottom: '15px' }}>
            <div className="row" style={style.receipt_header}>
              <div className="col-xs-12">
                <p style={{ margin: '0', textAlign: 'center' }}>
                  {getTranslatedString('landlordPortal.paymentsLedger.paymentLogUpcase')}
                </p>
              </div>
            </div>
            <div className="row" style={{ margin: 'auto', maxWidth: '500px' }}>
              <div className="row">
                <MediaQuery query="(min-device-width: 500px)">
                  <div className="col-xs-2" style={{ minWidth: '100px' }}>
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.date')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-3" style={{ minWidth: '100px' }}>
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.type')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-2">
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.due')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-2" style={{ paddingRight: 0 }}>
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.received')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-2">
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.balance')}{' '}
                    </h6>
                  </div>
                </MediaQuery>
                <MediaQuery query="(max-device-width: 500px)">
                  <div className="col-xs-3" style={{ minWidth: '100px' }}>
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.date')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-3">
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.received')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-3">
                    <h6 style={{ marginBottom: '10px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentsLedger.balance')}{' '}
                    </h6>
                  </div>
                </MediaQuery>
              </div>
              {this.props.unitPayments.length > 0 &&
                this.props.unitPayments.map((payment, index) => (
                  <div key={index} style={style.ledgerItem}>
                    <div className="row" style={style.ledgerItemRow}>
                      <MediaQuery query="(min-device-width: 500px)">
                        <div className="col-xs-2" style={{ minWidth: '100px' }}>
                          <p style={style.payment_details}>
                            {toFriendlyDateString(payment.due_date, {
                              language: this.props.currentLanguage,
                            })}
                          </p>
                          {payment.tenant && (
                            <p
                              style={{
                                ...style.payment_details,
                                marginTop: '-5px',
                                fontFamily: 'Circular-Bold',
                              }}
                            >
                              {getTranslatedString(`landlordPortal.paymentsLedger.paidBy`)}
                              {payment.tenant}
                            </p>
                          )}
                        </div>
                        <div className="col-xs-3" style={{ minWidth: '100px' }}>
                          {payment.id &&
                            !['Amenity Fee', 'Payment', 'Charge'].includes(
                              payment.payment_type
                            ) && (
                              <button
                                type="button"
                                className="link-button"
                                onClick={() => this.toggleDialog(payment.id)}
                                style={style.payment_details}
                              >
                                {getTranslatedString(
                                  `landlordPortal.paymentsLedger.${camelCase(payment.payment_type)}`
                                )}
                                {this.renderSubPaymentType(payment.sub_payment_type)}
                              </button>
                            )}
                          {(!payment.id ||
                            ['Amenity Fee', 'Payment', 'Charge'].includes(
                              payment.payment_type
                            )) && (
                            <p style={style.payment_details}>
                              {getTranslatedString(
                                `landlordPortal.paymentsLedger.${camelCase(payment.payment_type)}`
                              )}
                              {this.renderSubPaymentType(payment.sub_payment_type)}
                            </p>
                          )}
                        </div>
                        <div className="col-xs-2">
                          <p style={style.payment_details}>{formatMoney(payment.tenant_amount)}</p>
                        </div>
                        <div className="col-xs-2">
                          <p style={style.payment_details}>
                            {formatMoney(payment.tenant_amount_received)}
                          </p>
                        </div>
                        <div className="col-xs-2">
                          <p style={style.payment_balance_details}>
                            {formatMoney(payment.balance)}
                          </p>
                        </div>
                      </MediaQuery>

                      <MediaQuery query="(max-device-width: 459px)">
                        <div className="col-xs-4">
                          <p style={style.payment_details}>
                            {toFriendlyDateString(payment.due_date)}
                          </p>
                        </div>
                        <div className="col-xs-4">
                          <p style={style.payment_details}>
                            {formatMoney(payment.tenant_amount_received)}
                          </p>
                        </div>
                        <div className="col-xs-4">
                          <p style={style.payment_balance_details}>
                            {formatMoney(payment.balance)}
                          </p>
                        </div>
                      </MediaQuery>
                    </div>
                    <div className="row">
                      <div className="col-xs-12" style={style.ledgerItemDescription}>
                        {payment.description}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      );
    }

    renderSubPaymentType = (subPaymentType) => {
      if (!subPaymentType) return null;
      if (subPaymentType === 'credit_card_fees') {
        return ` (${getTranslatedString('landlordPortal.paymentsLedger.creditCardFees')})`;
      } else if (subPaymentType === 'direct_debit_fees') {
        return ` (${getTranslatedString('landlordPortal.paymentsLedger.directDebitFees')})`;
      } else {
        return ` (${subPaymentType})`;
      }
    };
  }
);

export default localize()(PaymentsLedger);
